export enum AvailabilityStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
  Leased = 'Leased',
  Pending = 'Pending',
  Sold = 'Sold',
  Withdrawn = 'Withdrawn'
}
